export const ACTION_LABELS = {
  en: {
    demoHeader: "Try Demo",
    primary: "Quote Shipping & logistics inquiries",
    secondary: "Find Shipping & logistics rates",
  },
  ar: {
    demoHeader: "ابدأ التجربة",
    primary: "انضم كمزود خدمة",
    secondary: "ابدأ الآن",
  },
};

const COPY_EN = {
  1: {
    brand: null,
    title: "SHIPPING & LOGISTICS\nMARKET",
    description: "Has Two Sides",
    showActions: false,
    titleStyle: "poster",
  },
  3: {
    brand: null,
    eyebrow: null,
    title: "IMPORTERS &\nTRADERS",
    description:
      "Actively looking for\nbest shipping quotations\nto move their shipments",
    showActions: false,
    titleStyle: "poster",
    align: "right",
  },
  4: {
    brand: null,
    label: "Importer Office",
    eyebrow: "Now they Can",
    title: "Request. Compare.\nSelect the best Quote",
    description:
      "Send your inquiry /RFQ,\nGet multiple quotations from verified\nfreight forwarding and logistics companies in Qatar,\ncompare and select,\nall in one place.",
    showActions: false,
  },
  7: {
    brand: null,
    eyebrow: null,
    title: "FREIGHT\nFORWARDERS &\nLOGISTICS\nPROVIDERS",
    description: "Looking for New Inquiries\nto Grow Business",
    showActions: false,
    titleStyle: "poster",
    align: "left",
  },
  5: {
    brand: null,
    label: "Service Provider Office",
    eyebrow: null,
    title: "Now They Can,\nReceive Inquiries,\nQuote, Win\nand Repeat",
    description:
      "Receive shipping and logistics services\ninquiries from Qatar market,\noffer your best quotation,\nwin the business,\nwithout any extra sale team\ncost or efforts.",
    showActions: false,
  },
  6: {
    brand: null,
    showLogo: true,
    layout: "finale",
    title:
      "First B2B shipping and logistics\nmarketplace platform of its kind\nin Qatar",
    description: "Connect. Compare. Grow.",
    showActions: true,
  },
};

const COPY_AR = {
  1: {
    brand: null,
    title: "سوق الشحن\nوالخدمات اللوجستية",
    description: "له جانبان",
    showActions: false,
    titleStyle: "poster",
  },
  3: {
    brand: null,
    eyebrow: null,
    title: "المستوردون\nوالتجار",
    description:
      "يبحثون باستمرار عن\nأفضل عروض أسعار الشحن\nلنقل شحناتهم",
    showActions: false,
    align: "right",
  },
  4: {
    brand: null,
    label: "مكتب المستورد",
    eyebrow: "الآن يمكنهم",
    title: "اطلب. قارن.\nاختر أفضل عرض سعر",
    description:
      "أرسل استفسارك / طلب عرض السعر،\nواحصل على عروض متعددة من شركات\nالشحن والخدمات اللوجستية الموثوقة في قطر،\nقارن واختر،\nكل ذلك في مكان واحد.",
    showActions: false,
    align: "right",
  },
  7: {
    brand: null,
    eyebrow: null,
    title: "شركات الشحن\nومزودو الخدمات\nاللوجستية",
    description: "يبحثون عن استفسارات جديدة\nلتنمية أعمالهم",
    showActions: false,
    align: "left",
  },
  5: {
    brand: null,
    label: "مكتب مزود الخدمة",
    eyebrow: "الآن يمكنهم",
    title: "استلام الاستفسارات\nوتقديم الأسعار والفوز\nوتكرار ذلك",
    description:
      "استلم استفسارات الشحن\nوالخدمات اللوجستية من السوق القطري،\nقدّم أفضل عرض سعر،\nواربح الأعمال دون تكاليف\nأو جهود فريق بيع إضافي.",
    showActions: false,
    align: "right",
  },
  6: {
    brand: null,
    showLogo: true,
    layout: "finale",
    title: "أول منصة B2B للشحن والخدمات\nاللوجستية من نوعها في قطر",
    description: "تواصل. قارن. نمُّ.",
    showActions: true,
  },
};

export function getSceneCopy(language) {
  return language === "ar" ? COPY_AR : COPY_EN;
}
